import BkButton, { type BkButtonVariant } from './ui/BkButton';

export type ModalButtonProps = {
  text: string;
  onClick?: () => void;
  active?: boolean;
  danger?: boolean;
  info?: boolean;
  isLink?: boolean;
  to?: string;
  disabled?: boolean;
};

function resolveVariant({
  active,
  danger,
  info,
}: Pick<ModalButtonProps, 'active' | 'danger' | 'info'>): BkButtonVariant {
  if (active) return 'primary';
  if (danger) return 'danger';
  if (info) return 'secondary';
  return 'secondary';
}

export default function ModalButton({
  text,
  onClick,
  active,
  danger,
  info,
  isLink,
  to,
  disabled,
}: ModalButtonProps) {
  return (
    <BkButton
      variant={resolveVariant({ active, danger, info })}
      size="md"
      to={isLink ? to : undefined}
      disabled={disabled}
      onClick={onClick}
      className="w-32 sm:w-36 md:w-40"
    >
      {text}
    </BkButton>
  );
}
